<footer class="footer">
  <div class="footer-content">
    <div class="footer-main">
      <div class="footer-products">
        <img
          src="assets/icons/rocket-logo.svg"
          alt="Rocket Logo"
          class="rocket-logo"
        />
        <div class="products-list">
          @for (product of rocketProducts; track product.titleKey) {
            <div class="product-item">
              <a
                [href]="product.url"
                appTrackedLink
                [trackId]="`footer:foc:${product.trackId}`"
                class="product-title-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h3 class="product-title">
                  {{ product.titleKey | translate }}
                </h3>
              </a>
              <p class="product-description">
                {{ product.descriptionKey | translate }}
              </p>
            </div>
          }
        </div>
      </div>

      <div class="footer-links">
        <div class="links-column">
          <h3 class="column-title">
            {{ "footer.rocketClose.heading" | translate }}
          </h3>
          <ul class="links-list">
            @for (link of rocketCloseLinks; track link.textKey) {
              <li>
                <a
                  [href]="link.url"
                  appTrackedLink
                  [trackId]="`footer:company:${link.trackId}`"
                  class="footer-link"
                >
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="links-column">
          <h3 class="column-title">{{ "footer.legal.heading" | translate }}</h3>
          <ul class="links-list">
            @for (link of legalLinks; track link.textKey) {
              <li>
                <a
                  [href]="link.url"
                  appTrackedLink
                  [trackId]="`footer:legal:${link.trackId}`"
                  class="footer-link"
                >
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="links-column">
          <h3 class="column-title">
            {{ "footer.support.heading" | translate }}
          </h3>
          <ul class="links-list">
            @for (link of supportLinks; track link.textKey) {
              <li>
                <a
                  [href]="link.url"
                  appTrackedLink
                  [trackId]="`footer:support:${link.trackId}`"
                  class="footer-link"
                >
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="social-apps">
        <div class="social-links">
          @for (social of socialLinks; track social.name) {
            <a
              [href]="social.url"
              appTrackedLink
              [trackId]="`footer:social:${social.trackId}`"
              class="social-link"
              [attr.aria-label]="social.name"
            >
              <img
                [src]="social.icon"
                [alt]="social.name"
                class="social-icon"
              />
            </a>
          }
        </div>
      </div>

      <div class="app-downloads">
        <a
          href="https://apps.apple.com/us/app/rocket-mortgage/id431156417"
          appTrackedLink
          [trackId]="'footer:app-download:ios'"
          target="_blank"
          rel="noopener noreferrer"
          class="app-badge apple-badge"
          aria-label="Download on the App Store"
        >
          <img
            src="assets/icons/apple-store-logo.svg"
            alt="Download on the App Store"
            class="app-store-logo"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?hl=en_US&id=com.quickenloans.myql"
          appTrackedLink
          [trackId]="'footer:app-download:android'"
          target="_blank"
          rel="noopener noreferrer"
          class="app-badge google-badge"
          aria-label="Get it on Google Play"
        >
          <img
            src="assets/icons/google-store-logo.svg"
            alt="Get it on Google Play"
            class="app-store-logo"
          />
        </a>
      </div>
    </div>
  </div>

  <div class="footer-divider"></div>

  <div class="footer-legal">
    <div class="legal-content">
      <p class="copyright-text">
        {{ "footer.copyrightShort" | translate: { year: currentYear } }}
      </p>
      <p class="copyright-text">
        {{ "footer.copyrightLong" | translate }}
      </p>
      <img
        src="assets/icons/EHO.svg"
        alt="Equal Housing Opportunity"
        class="legal-logo"
      />
    </div>
  </div>
</footer>
